import React, { useEffect, useMemo, useState } from "react";
import { useLenis } from "lenis/react";
import { useNavigate, useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import ProductGrid from "@/components/ProductGrid";
import Footer from "@/components/Footer";
import { fetchProducts } from "@/lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  const lenis = useLenis();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetchProducts().then(setProducts).catch(() => {});
  }, []);

  useEffect(() => {
    if (lenis) window.__lenis = lenis;
  }, [lenis]);

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target && lenis && products.length) {
      const t = setTimeout(() => {
        lenis.resize?.();
        lenis.scrollTo(`#${target}`, { offset: -80, duration: 1.2 });
        window.history.replaceState({}, "");
      }, 300);
      return () => clearTimeout(t);
    }
  }, [location.state, lenis, products]);

  const bestsellers = useMemo(() => products.filter((p) => p.bestseller), [products]);

  const openProduct = (p) => navigate(`/produs/${p.slug}`);
  const scrollToCollection = () => lenis && lenis.scrollTo("#colectie", { offset: -80, duration: 1.4 });

  return (
    <main>
      <Hero onExplore={scrollToCollection} />
      <Marquee items={["Lavandă", "Glamour", "Pădure Alpină", "Argan", "Spring Time", "Musk & Talc", "Leno Blue"]} />
      <ProductGrid products={products} onOpen={openProduct} />
      <Manifesto />
      <Footer />
    </main>
  );
}
